<template>
  <div class="f360-insight-feedback">
    <span>{{ label }}</span>

    <F360FeedbackButton
      label="Sim"
      icon="thumb_up"
      value="true"
      :is-active="usefulInsight === true"
      @select="emitFeedback"
    />

    <F360FeedbackButton
      label="Nao"
      icon="thumb_down"
      value="false"
      :is-active="usefulInsight === false"
      @select="emitFeedback"
    />
  </div>
</template>

<script setup lang="ts">
type TProps = {
  usefulInsight: boolean | null;
  label: string;
}
import F360FeedbackButton from './F360FeedbackButton.vue'
defineProps<TProps>();
const emit = defineEmits<{
  (e: "feedback", value: "true" | "false"): void;
}>();
const emitFeedback = (value: "true" | "false") => {
  emit("feedback", value);
};
</script>

<style scoped lang="scss">
.f360-insight-feedback {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #5d5d5d;
  font-size: 11px;
  line-height: 14px;
}

@media screen and (max-width: 768px) {
  .f360-insight-feedback {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
